var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"mt-4"},[_vm._v(_vm._s(_vm.$t("checkEmail")))]),_c('p',{staticClass:"mt-4 text-center"},[_c('strong',[_vm._v(_vm._s(_vm.$t("passwordEmail")))])]),_c('p',{staticClass:"mt-5 mb-3 ml-3"},[_c('router-link',{attrs:{"to":"/"}},[_vm._v(_vm._s(_vm.$t("back")))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }